<template>
  <div class="row">
    <div class="col-12">

      <div class="card editor-card o-hidden border-0 mb-5 mt-3">
        <div class="card-body p-0">
          <!-- Nested Row within Card Body -->
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newCard"
}
</script>

<style scoped>
.editor-card {
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
</style>